import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Stage, StagePayload, Stages } from '../../common/models'

export const getAllStages = (params?: PaginationParams) =>
  http.get<Pagination<Stages>>('/operations/stages', {
    params,
  })

export const createStages = (data: StagePayload) =>
  http.post<Stage>('/operations/stages', data)

export const updateStages = (id: string, data: StagePayload) =>
  http.put<Stage>(`/operations/stages/${id}`, data)

export const unpublishStages = (ids: string[]) =>
  http.put('/operations/stages/unpublish', {
    ids,
  })

export const publishStages = (ids: string[]) =>
  http.put('/operations/stages/publish', {
    ids,
  })

export const deleteStages = (ids: string[]) =>
  http.delete('/operations/stages', {
    data: {
      ids,
    },
  })

export const getStages = (id: string) =>
  http.get<Stage>(`/operations/stages/${id}`)
